import * as Actions from '../../actions';

const initialState = { data: null };

const QuotaLeasingReducer = function (state = initialState, action) {
    switch (action.type) {
        case Actions.GET_QUOTA_LEASING_DETAILS:
            return { ...state, data: { ...action.payload } };
        default:
            return state;
    }
};

export default QuotaLeasingReducer;
